//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.CylindricalMillingBuilder.js";
import "../CAM/CAM.CylinderMillingCutParameters.js";
import "../CAM/CAM.OppositeDirection.js";
let d=[[[0,"AxialDistance",0,"CAM.InheritableToolDepBuilder",0],[0,"BlankDiameter",1,0],[0,"BlankDistance",0,"CAM.InheritableToolDepBuilder",0],[0,"CleanupPasses",1,0],[1,"CutParameters",0,"CAM.CylinderMillingCutParameters",1],[0,"CutPattern",1,0],[0,"DepthPerRevolution",1,0],[0,"DiameterForHelix",1,0],[0,"HelixDiameter",0,"CAM.InheritableToolDepBuilder",0],[0,"MinimumHelixDiameter",0,"CAM.InheritableToolDepBuilder",0],[0,"MotionOutput",1,0],[0,"OffsetFromStartDiameter",0,"CAM.InheritableToolDepBuilder",0],[0,"OppositeDirection",1,1],[1,"OppositeDirectionBuilder",0,"CAM.OppositeDirection",1],[0,"RampAngle",0,"CAM.InheritableDoubleBuilder",0],[0,"RetractOutputMode",1,0],[0,"SpiralThickness",0,"CAM.InheritableToolDepBuilder",0],[0,"StartDiameter",0,"CAM.InheritableToolDepBuilder",0]],[],[]];
SPLM.CAM.CylinderMillingBuilder = class extends SPLM.CAM.CylindricalMillingBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.CylinderMillingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.CylinderMillingBuilder.MotionOutputTypes = Object.freeze({
    "MachineCycle" : "MachineCycle", "SingleMoves" : "SingleMoves"});

SPLM.CAM.CylinderMillingBuilder.CutPatternTypes = Object.freeze({
    "Spiral" : "Spiral", "Helical" : "Helical", "HelicalAndSpiral" : "HelicalAndSpiral", "Circular" : "Circular"});

SPLM.CAM.CylinderMillingBuilder.DiameterForHelixTypes = Object.freeze({
    "Diameter" : "Diameter", "SpiralThickness" : "SpiralThickness", "OffsetFromStartDiameter" : "OffsetFromStartDiameter"});

SPLM.CAM.CylinderMillingBuilder.DepthPerRevolutionTypes = Object.freeze({
    "Distance" : "Distance", "RampAngle" : "RampAngle"});

SPLM.CAM.CylinderMillingBuilder.BlankDiameterTypes = Object.freeze({
    "Diameter" : "Diameter", "Distance" : "Distance"});

SPLM.CAM.CylinderMillingBuilder.RetractOutputModeType = Object.freeze({
    "ClearanceOnly" : "ClearanceOnly", "ClearanceInitial" : "ClearanceInitial", "Always" : "Always", "PostDriven" : "PostDriven"});

export default SPLM;